module.exports = __webpack_public_path__ + "img/paypal-button-text.534d1a90.svg";